import {Injectable} from "@angular/core";
import {environment} from "src/app/environments/environment";
import {PushNotifications} from "@capacitor/push-notifications";
import {AuthenticationService} from "src/app/application/authentication/authentication.service";

@Injectable({
  providedIn: 'root'
})
export class PushNotificationService {

  private currentNotificationToken?: string;

  constructor(
    private authenticationService: AuthenticationService,
  ) {}

  async registerForPushNotifications() {
    if (['web', ''].includes(environment.platform)) return;

    await PushNotifications.requestPermissions();
    await PushNotifications.register();
  }

  init() {
    if (['web', ''].includes(environment.platform)) return;

    PushNotifications.addListener('pushNotificationActionPerformed', notification => {
      console.log('Push notification action performed', notification.actionId, notification.inputValue);
    });

    PushNotifications.addListener('registrationError', registrationError => {
      console.error(`Registration for push notifications failed: ${registrationError.error}`)
    })

    PushNotifications.addListener('registration', async token => {
      const notificationToken = token.value;

      if (this.currentNotificationToken === notificationToken) return;

      this.currentNotificationToken = notificationToken;
      this.authenticationService.extendSession(notificationToken);
    });
  }
}
